import { Pipe, PipeTransform } from '@angular/core';
import { CONSTANTS } from 'src/app/shared/constants/constants';

@Pipe({
  name: 'deviceLockImage',
})
export class DeviceLockImagePipe implements PipeTransform {
  readonly CONSTANTS = CONSTANTS;
  transform(deviceState: string): string {
    let imageType = '';

    switch (deviceState) {
      case CONSTANTS.OFFLINE:
        imageType = 'ico-lock-circle-outline-red.svg';
        break;
      case CONSTANTS.ONLINE:
        imageType = 'ico-home-lock.svg';
        break;
      case '':
        imageType = 'ico-lock-gray-circle.svg';
        break;
      default:
        imageType = 'ico-lock-gray-circle.svg';
        break;
    }

    return '/assets/svg/' + imageType;
  }
}
